module.exports = __webpack_public_path__ + "static/media/logo.f1e13726.svg";